import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import {
  ContentControlledEditingDirective,
  ContentControlledEditingDirectiveViewModel
} from 'app/js/src/domain/content-control/editing-directive';
import { MillisecondsToFormattedDuration } from "app/js/src/domain/common/ui-utils";
@Component({
  selector: "evrideo-content-control-studio-timeline-inclusive-segment",
  templateUrl:
    "./content-control-studio-timeline-inclusive-segment.component.html",
  styleUrl:
    "./content-control-studio-timeline-inclusive-segment.component.scss",
})
export class ContentControlStudioTimelineInclusiveSegmentComponent {
  @Input() segment: ContentControlledEditingDirectiveViewModel;
  @Input() width: number;
  @Input() height: number;
  @ViewChild("rect") rect: ElementRef<SVGElement>;
  public finalText: string;
  MillisecondsToFormattedDuration = MillisecondsToFormattedDuration;
  ngAfterViewInit() {
    this.applyStyles();
  }
  ngOnChanges() {
    this.applyStyles();
    if (this.segment && this.segment.title) {
      const duration = this.segment.endsAtMs - this.segment.startsAtMs;
      this.finalText = `${this.segment.title} ${MillisecondsToFormattedDuration(duration, true)}`;
    }
  }

  applyStyles() {
    if (this.rect && this.height) {
      this.rect.nativeElement.setAttribute("height", this.height.toString());
      this.rect.nativeElement.setAttribute("viewBox", `0 0 72 ${this.height}`);
      this.rect.nativeElement
        .querySelector("rect.line")
        .setAttribute("height", this.height.toString());
    }
  }
}
